import { createPortal } from 'react-dom';
import React, { useEffect, useState } from 'react';

import IconFont from '../IconFont';

import styles from './index.module.scss';

export default CommonModal;
function CommonModal({
  show,
  close,
  content,
  isOpenBlankClick,
  className,
  closeBtnClassName,
  hasCloseBtn,
}: {
  show: boolean;
  close: () => void;
  content: React.ReactElement;
  hasCloseBtn?: boolean;
  isOpenBlankClick?: boolean;
  closeBtnClassName?: string;
  className?: string;
}) {
  const [local] = useState({
    node: typeof window !== 'undefined' ? document.createElement('div') : undefined,
  });

  useEffect(() => {
    if (local.node) {
      document.body.appendChild(local.node);
    }
    return () => {
      local.node?.remove();
    };
  }, []);
  return show && local.node
    ? createPortal(
      <div
        className={`${styles.CommonModal} ${className || ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (isOpenBlankClick) {
            close();
          }
        }}
      >
        <div className={styles.table}>
          <div className={styles.tableCell}>
            <div
              className={styles.content}
              style={{ display: 'inline-block' }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {hasCloseBtn && (
              <IconFont
                className={`${styles.closeButton} ${closeBtnClassName}`}
                fontSize={18}
                name="crossBlack"
                onClick={() => {
                  close();
                }}
              />
              )}
              {content}
            </div>
          </div>
        </div>
      </div>,
      local.node,
    )
    : null;
}
